<template>
	<div v-loading="loading">
		<div class="item-block">
			<div class="payment-detail">
				<div class="payment-media">
					<el-row>
						<el-col :span="4">
							<div class="media-left"><i class="el-icon-circle-check ns-text-color"></i></div>
						</el-col>
						
						<el-col :span="16">
							<div class="media-body">
								<el-row>
									<el-col :span="12">
										<div class="payment-text">您的订单已提交成功，正在等待处理！</div>
										<div>
											<span>应付金额：</span>
											<span class="payment-money ns-text-color">￥{{ account_payable }}元</span>
										</div>
									</el-col>
									<el-col :span="12"></el-col>
								</el-row>
							</div>
						</el-col>
						
						<el-col :span="4">
							<div class="media-right">
								<div class="el-button--text" @click="orderOpen ? (orderOpen = false) : (orderOpen = true)">
									订单信息
									<i :class="orderOpen ? 'rotate' : ''" class="el-icon-arrow-down"></i>
								</div>
							</div>
						</el-col>
					</el-row>
				</div>
				
				<div class="order-info" v-if="orderOpen">
					<el-row>
						<el-col :span="4" class="order-info-left"></el-col>
						<el-col :span="20">
							<div class="line"></div>
							<div class="order-item">
								<div class="item-label">交易单号：</div>
								<div class="item-value">{{ payInfo.out_trade_no }}</div>
							</div>
							<div class="order-item">
								<div class="item-label">订单内容：</div>
								<div class="item-value">{{ payInfo.pay_detail }}</div>
							</div>
							<div class="order-item">
								<div class="item-label">订单金额：</div>
								<div class="item-value">￥{{ order_type=='order'?payInfo.order_money:payInfo.pay_money }}</div>
							</div>
							<div class="order-item">
								<div class="item-label">创建时间：</div>
								<div class="item-value">{{ $timeStampTurnTime(payInfo.create_time) }}</div>
							</div>
						</el-col>
					</el-row>
				</div>
			</div>
		</div>
		<!--使用余额-->
        <div class="item-block" v-if="balance_show == 1 && order_type!=='recharge' && balance > 0">
            <div class="block-text">当前余额：<span style="color: #ff547b;">￥{{ balance }}</span></div>
            <div class="pay-type-list">
                <div class="pay-type-item" :class="is_balance ? '' : 'active'" @click="useBalance(0)">
                    不使用余额
                </div>
                <div class="pay-type-item" :class="is_balance ? 'active' : ''" @click="useBalance(1)">
                    使用余额
                </div>
                <div class="clear"></div>
            </div>
        </div>
		<div class="item-block" v-if="showPayTypeList">
			<div class="block-text">支付方式</div>
			<div class="pay-type-list" v-if="payTypeList.length">
				<div class="pay-type-item" v-for="(item, index) in payTypeList" :key="index"
				     :class="payIndex == index ? 'active' : ''" @click="switchPayType(index)">
					{{ item.name }}
				</div>
				<div class="clear"></div>
			</div>
			<div class="no-pay-type" v-else>
				<p>商家未配置支付方式</p>
			</div>
		</div>
		
		<div class="item-block" v-if="payTypeList.length">
			<div class="order-submit">
				<el-button type="primary" class="el-button--primary" @click="payBefore">立即支付</el-button>
			</div>
			<div class="clear"></div>
		</div>
		
		<el-dialog title="请确认支付是否完成" :visible.sync="dialogVisible" width="23%" top="30vh" class="confirm-pay-wrap">
			<div class="info-wrap">
				<i class="el-message-box__status el-icon-warning"></i>
				<span>完成支付前请根据您的情况点击下面的按钮</span>
			</div>
			<span slot="footer" class="dialog-footer">
				<el-button @click="goIndex" size="small">返回首页</el-button>
				<el-button type="primary" @click="goOrderList" size="small">已完成支付</el-button>
			</span>
		</el-dialog>
		
		<!-- 微信支付弹框 -->
		<el-dialog :title="dialogTitle" :visible.sync="openQrcode" width="370px" center>
			<div class="wechatpay-box"><img :src="payQrcode"/></div>
		</el-dialog>
	</div>
</template>

<script>
import {checkPayStatus, getBalanceConfig, getPayInfo, getPayType, pay} from '@/api/pay';
import Config from '@/utils/config';
import {apiOrderPay, apiMemberBalance , apiOrderDetail} from "@/api/order/order";
import { verifyPayPassword } from "@/api/order/payment"
export default {
	name: 'pay',
	components: {},
	data: () => {
		return {
			orderOpen: false,
			outTradeNo: '',
			payInfo: {
				pay_money: 0
			},
			payIndex: 0,
			payTypeList: [],
			payUrl: '',
			timer: null,
			payQrcode: '',
			openQrcode: false,
			loading: true,
			test: null,
			dialogVisible: false,
			isFirstClickPay: true,
			// 节流参数
			ifPayLoading:false,
			dialogTitle:'',
			titleRule:{
				wechatpay:'请使用微信扫码支付',
				wechatpaytwo:'请使用微信扫码支付',
				alipay:'请使用支付宝扫码支付',
				tonglianpay:'请使用微信或支付宝扫码支付'
			},
			member_id:'',
			balance:0,
			balance_show:1,
			pay_password_status:1,
			is_balance:0,
			orderDetail:{},
			order_type:'order',
			payBeforeLoading:false
		};
	},
	computed: {
		account_payable(){
			let money = this.order_type=='order'?this.payInfo.order_money:this.payInfo.pay_money;
			if(this.is_balance){
				if(this.balance >= money){
					money = 0;
				}else{
					money = money - this.balance;
				}
			}
			if(typeof money == 'number'){
				money = Number(money.toFixed(2));
			}
			return money;
		},
		showPayTypeList(){
			let bool = true;
			if(this.is_balance && this.account_payable == 0){
				bool = false;
			}
			return bool;
		}
	},
	created() {
		if (!this.$route.query.code) {
			this.$router.push({path: '/'});
			return;
		}
		if(this.$route.query.type){
			this.order_type = this.$route.query.type;
		}
		this.outTradeNo = this.$route.query.code;
		this.getPayInfo();
		this.getPayType();
		this.checkPayStatus();
	},
	mounted() {
		this.getBalanceConfig();
	},
	destroyed() {
		clearInterval(this.timer);
		this.timer = null;
	},
	methods: {
		getBalanceConfig() {
			getBalanceConfig().then(res => {
				if (res.code >= 0 && res.data) {
					this.balance_show = res.data.balance_show;
					this.pay_password_status = res.data.pay_password_status == 0 ? 0 : 1;
					if (this.balance_show != 1) this.is_balance = 0;
				}
			}).catch(() => {});
		},
		useBalance(is_balance){
			this.is_balance = is_balance;
		},
		getOrderDetail(id){
			if(!id){
				return;
			}
			apiOrderDetail({order_id: id}).then(res => {
				console.log('获取订单详情：',res);
				if (res.code >= 0) {
					this.orderDetail = res.data;
					this.getBalance();
				}
			});
		},
		getPayInfo() {
			return getPayInfo({out_trade_no: this.outTradeNo, forceLogin: true})
				.then(res => {
					const {code, message, data} = res;
					if (code >= 0 && data) {
						this.payInfo = res.data;
						this.getOrderDetail(data.order_id);
					}else{
						this.$message({message: message || '订单支付失败', type: 'error'});
						setTimeout(()=>{
							this.$router.push({path: '/member/order_list'});
						},1000)
					}
					this.loading = false;
				})
				.catch(err => {
					this.loading = false;
					this.$message.error({
						message: err.message,
						duration: 2000,
						onClose: () => {
							this.$router.push({path: '/member/order_list'});
						}
					});
				});
		},
		getBalance(){
			this.member_id = this.orderDetail.member_id;
			apiMemberBalance({member_id:this.member_id}).then(res => {
				console.log('获取余额：',res);
				if (res.code >= 0) {
					this.balance = res.data.balance_total;
				}
			});
		},
		getPayType() {
			getPayType({
				order_type:this.order_type,
			}).then(res => {
					if (res.code >= 0) {
						this.payTypeList = res.data;
					}
				})
				.catch(err => {
					this.$message.error(err.message);
				});
		},
		checkPayStatus() {
			this.timer = setInterval(() => {
				checkPayStatus({out_trade_no: this.outTradeNo})
					.then(res => {
						const {code, message, data} = res;
						if (code >= 0) {
							if (code == 0) {
								if (data.pay_status == 2) {
									clearInterval(this.timer);
									this.dialogVisible = false;
									this.$router.push({path: '/result?code=' + this.payInfo.out_trade_no});
								}
							} else {
								clearInterval(this.timer);
							}
						}
					})
					.catch(err => {
						clearInterval(this.timer);
						this.$router.push({path: '/'});
					});
			}, 1000);
		},
		switchPayType(index){
			if(this.payIndex!=index){
				this.payIndex = index;
			}
		},
		payBefore(){
			if(this.payBeforeLoading)return;
			this.payBeforeLoading = true;
			var payType = this.payTypeList[this.payIndex];
			if((this.is_balance || payType.type==='creditpay') && this.pay_password_status == 1){
				let arr = [];
				let postPayType = '';
				if(this.is_balance){
					arr.push('balance')
				}
				if(payType.type==='creditpay'){
					arr.push('creditpay')
				}
				postPayType = arr.join('_');
				this.$prompt('请输入支付密码', '支付提示', {
					confirmButtonText: '确认',
					cancelButtonText: '取消',
					inputType: 'password',
					inputValidator: (value) => {
						if (!value) {
							return '密码不能为空';
						}
						if (value.length !== 6) {
							return '密码长度必须为6位';
						}
						if (!/^\d+$/.test(value)) {
							return '密码只能为数字';
						}
						return true;
					}
				}).then(({ value }) => {
					verifyPayPassword({ member_id:this.member_id,pay_password: value,pay_money: this.account_payable,pay_type: postPayType,out_trade_no: this.outTradeNo }).then(res => {
						if (res.code >= 0) {
							this.pay();
						} else {
							this.$message({ type: 'error', message: res.message || '密码校验失败' });
						}
					}).catch(err => {
						this.$message({ type: 'error', message: '网络错误，请稍后重试' });
					});
				}).catch(() => {
					console.log('已取消使用余额');
				});
			}else{
				this.pay();
			}
			setTimeout(()=>{
				this.payBeforeLoading = false;
			},1000)
		},
		async pay() {
			console.log('支付调用');
			if(this.ifPayLoading)return;
			var payType = this.payTypeList[this.payIndex];
			if (!payType) return;
			this.ifPayLoading = true;
			if (payType.type == 'alipay') var newWindow = window.open();
			let httpUrl = window.location.origin || Config.webDomain;
			let return_url = encodeURIComponent(httpUrl + '/result?code=' + this.outTradeNo);
			let nextBool = false;
			if(this.order_type === 'order'){
				await apiOrderPay({order_ids: this.payInfo.order_id,is_balance: this.is_balance}).then(res => {
					if(res.code>=0){
						this.outTradeNo = res.data;
						history.pushState({}, '', '/pay?code=' + this.outTradeNo);
					}else{
						nextBool = true;
						this.$message({message: res.message || '订单支付失败', type: 'error'});
						this.ifPayLoading = false;
					}
				});
			}
			if(nextBool)return;
			await this.getPayInfo();
			this.isFirstClickPay = false;
			let typeBool = (this.is_balance&&this.account_payable==0);
			if(this.outTradeNo){
				pay({is_balance: this.is_balance,out_trade_no: this.payInfo.out_trade_no, pay_type: (typeBool?"BALANCE":payType.type), app_type: 'pc', return_url})
				.then(res => {
					const {code, message, data} = res;
					if (code >= 0) {
						this.dialogTitle = this.titleRule[payType.type];
						let temType = (typeBool?"BALANCE":payType.type);
						switch (temType) {
							case 'alipay':
								this.payUrl = res.data.data;
								newWindow.location.href = this.payUrl;
								this.open();
								break;
							case 'wechatpay':
								this.payQrcode = res.data.qrcode;
								this.openQrcode = true;
								break;
							case 'wechatpaytwo':
								this.payQrcode = res.data.qrcode;
								this.openQrcode = true;
								break;
							case 'tonglianpay':
								this.payQrcode = res.data.qrcode;
								this.openQrcode = true;
								break;
							default:
								this.goOrderList();
								break;
						}
						this.ifPayLoading = false;
					} else {
						this.$message({message: message, type: 'warning'});
						this.ifPayLoading = false;
					}
				})
				.catch(err => {
					this.$message.error(err.message);
					this.ifPayLoading = false;
				});
			}
		},
		open() {
			this.dialogVisible = true;
		},
		goIndex() {
			clearInterval(this.timer);
			this.dialogVisible = false;
			this.$router.push({path: '/'});
		},
		goOrderList() {
			clearInterval(this.timer);
			this.dialogVisible = false;
			this.$router.push({path: '/member/order_list'});
		}
	}
};
</script>

<style lang="scss" scoped>
.clear {
	clear: both;
}

.item-block {
	padding: 0 15px 1px;
	margin: 10px 0;
	border-radius: 0;
	border: none;
	background: #ffffff;
	
	.block-text {
		border-color: #eeeeee;
		color: $ns-text-color-black;
		padding: 7px 0;
		border-bottom: 1px;
	}
}

.media-left {
	text-align: center;
	
	i {
		font-size: 65px;
	}
}

.payment-detail {
	padding: 30px 0;
	transition: 2s;
}

.media-right {
	text-align: center;
	line-height: 65px;
	cursor: pointer;
	
	i.rotate {
		transform: rotate(180deg);
		transition: 0.3s;
	}
}

.payment-text {
	font-size: 20px;
}

.payment-time {
	font-size: 12px;
	line-height: 65px;
	color: #999;
}

//支付方式
.order-submit {
	float: right;
	padding: 10px;
}

.pay-type-list {
	padding: 20px 0;
}

.no-pay-type {
	padding: 30px 0;
	text-align: center;
}

.pay-type-item {
	display: inline-block;
	border: 2px solid #eeeeee;
	padding: 5px 20px;
	margin-right: 20px;
	cursor: pointer;
}

.pay-type-item.active {
	border-color: $base-color;
}

.mobile-wrap {
	width: 300px;
}

.order-info {
	.order-item {
		padding: 1px 0;
		
		.item-label {
			display: inline-block;
			width: 100px;
		}
		
		.item-value {
			display: inline-block;
		}
	}
	
	.line {
		width: 100%;
		height: 1px;
		background: #f2f2f2;
		margin: 20px 0 10px 0;
	}
	
	.order-info-left {
		height: 1px;
	}
}

.wechatpay-box {
	text-align: center;
	
	img {
		width: 90%;
	}
}

.confirm-pay-wrap {
	.el-dialog__body {
		padding: 10px 15px;
	}
	
	.info-wrap {
		i {
			position: initial;
			vertical-align: middle;
			transform: initial;
		}
		
		span {
			vertical-align: middle;
			padding: 0 10px;
		}
	}
}
</style>
<style lang="scss">
.confirm-pay-wrap {
	.el-dialog__body {
		padding: 10px 15px;
	}
	
	.el-dialog__footer {
		padding-top: 0;
		padding-bottom: 10px;
	}
}
.el-dialog{
	border-radius: 20px !important;
	overflow: hidden;
}
.el-dialog__header{
	background-color: #f5f5f5;
}
.el-dialog__title{
	font-weight: bold;
	font-size: 20px;
}
.el-dialog__headerbtn{
	font-size: 28px;
	line-height: 28px;
	background-color: #ff547b;
	border-radius: 50%;
	padding: 3px;
	box-sizing: border-box;
	top: 14px;
	right: 11px;
	>.el-dialog__close{
		color: #fff !important;
	}
}
</style>
